import { themeGet } from '@styled-system/theme-get'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import styled from 'styled-components/macro'
import { compose, position, space } from 'styled-system'
import { CONTROL_STATUS } from '@trustero/trustero-api-web/lib/model/control_pb'
import { StatusStyles } from '../Status'
import { ReactComponent as CelebrateIcon } from '../Icons/assets/celebrate-icon.svg'
import { getStatusKey } from '../Status/StatusDropdown.helpers'

export const ProgressMapContainer = styled.div`
  position: relative;
  align-self: center;
  margin-left: auto;
  width: 360px;
`

export const ProgressMapTitle = styled.p`
  position: absolute;
  bottom: 100%;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  padding-bottom: 2px;
  :before {
    content: 'Getting Controls Ready';
  }
`

export const ProgressBar = styled.div<{ percentage: number }>`
  display: flex;
  position: relative;
  height: 10px;
  border-radius: 9px;
  overflow-x: hidden;
  background-color: ${themeGet('colors.border.neutral.superlight')};

  :after {
    content: '';
    position: absolute;
    z-index: 1;
    width: ${(props) => props.percentage}%;
    height: 100%;
    background-color: ${themeGet('colors.fill.status.success.light')};
  }
`

export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 180px;
`

export const Percentage = styled.p`
  position: absolute;
  top: 100%;
  right: 0;
  font-size: 14px;
`

export const ProgressPercent = styled.span`
  font-weight: 800;
`

type ProgressDetailsProps = {
  isHovered: boolean
  percentage: number
}

export const ProgressDetails = styled.div.attrs({
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: '0',
})<ProgressDetailsProps>`
  ${compose(position, space)}
  display: ${(props) =>
    props.isHovered && props.percentage >= 0 ? 'flex' : 'none'};
  :hover {
    display: ${(props) => (props.percentage >= 0 ? 'flex' : 'none')};
  }
  flex-direction: column;
  z-index: 5;
  width: 180px;
  padding: 16px 16px 16px 16px;
  border-radius: 6px;
  white-space: pre;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
`

export const Breakdown = styled.ul`
  display: flex;
  flex-direction: column;
  padding-inline-start: 0px;
  font-size: 12px;
  font-weight: 500;
`
export const Total = styled.li`
  display: block;
  margin-top: 8px;
  padding: 4px 8px 4px 4px;
`

export const Count = styled.li<{ status: CONTROL_STATUS }>`
  color: ${({ status }) =>
    StatusStyles[getStatusKey(status, MODEL_TYPE.CONTROL)].color};
  background-color: ${({ status }) =>
    StatusStyles[getStatusKey(status, MODEL_TYPE.CONTROL)].bg};
  display: block;
  margin-top: 8px;
  padding: 4px 8px 4px 8px;
  border-radius: 2px;
`

export const MoreDetails = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  width: 100%;
  float: right;
`
export const Left = styled.p`
  float: left;
`
export const Right = styled.p`
  float: right;
`
export const ProgressMapCelebrateIcon = styled(CelebrateIcon)`
  margin-right: 10px;
`
